import React, { useState } from 'react';
import { ListGroup, Button, Row, Col, Image, Modal } from 'react-bootstrap';
import { Trash3Fill, Whatsapp } from 'react-bootstrap-icons';
import { useCarrito } from './CarritoContext';
import { useParams } from 'react-router-dom';
import { API } from '../../../../api/URL_API';
import axios from 'axios';

function CarUni({ show, handleClose }) {
    const {
        carrito,
        removeFromCarrito,
        increaseQuantity,
        decreaseQuantity,
        clearCarrito,
        calculateShippingCost,
        configEnvio,
        calculateDiscount,
        calculateTotalWithDiscount,
        configDescuento = {}
    } = useCarrito();

    const { idSucursal } = useParams();
    const [isSending, setIsSending] = useState(false);

    const isEnvioDisabled = configEnvio?.tipoConfig === 'desable';
    let envioCosto = calculateShippingCost();
    if (isEnvioDisabled) {
        envioCosto = 0;
    }

    // Obtenemos el descuento y lo mostramos en consola
    const descuento = calculateDiscount();

    // Cálculo del precio total (sin descuento aplicado)
    const totalPrecio = carrito.reduce((total, product) => {
        const price = configDescuento?.tipoConfig === 'desable'
            ? parseFloat(product.precioU.toString().replace('$', '').replace(',', ''))
            : parseFloat(
                // Si el descuento es distinto de null (aunque sea 0) usamos precioU,
                // de lo contrario (si es null) usamos precioM.
                descuento !== null
                    ? (() => {
                        return product.precioU.toString().replace('$', '').replace(',', '');
                    })()
                    : (() => {
                        return product.precioM.toString().replace('$', '').replace(',', '');
                    })()
            );
        const quantity = Number(product.quantity) || 1;
        return total + (price * quantity);
    }, 0);

    const porcentajeDescuento = descuento; // Se usa para mostrar el descuento
    const totalConDescuento = calculateTotalWithDiscount();

    // Calcular la cantidad total de productos
    const totalProductosQuantity = carrito.reduce(
        (acc, product) => acc + (Number(product.quantity) || 1),
        0
    );

    const handleRemoveProduct = (idProducto, selectedColor, selectedSize) => {
        removeFromCarrito(idProducto, selectedColor, selectedSize);
    };

    const handleIncreaseQuantity = (idProducto, selectedColor, selectedSize) => {
        increaseQuantity(idProducto, selectedColor, selectedSize);
    };

    const handleDecreaseQuantity = (idProducto, selectedColor, selectedSize) => {
        decreaseQuantity(idProducto, selectedColor, selectedSize);
    };

    const handleClearCarrito = () => {
        clearCarrito();
    };

    const formatPhoneNumber = (number) => {
        const cleanedNumber = number.replace(/\D/g, '');
        return `+57${cleanedNumber}`;
    };

    // Función para formatear montos (con separador de miles)
    const formatCurrency = (amount) => {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    const handleSendPedido = async () => {
        setIsSending(true);
        try {
            // Determinar el tipo de pedido según la configuración de precios
            const tipoPedido = configDescuento?.tipoConfig === 'desable' || descuento !== null
                ? 'unidad'
                : 'distribucion';
            const pedido = {
                idCliente: 36,
                idSucursal: idSucursal ? parseInt(idSucursal) : 1,
                tipo: tipoPedido,
                creacion: new Date().toISOString().split('T')[0],
                vence: new Date(new Date().setDate(new Date().getDate())).toISOString().split('T')[0],
                costoEnvio: envioCosto,
                totalProductos: totalConDescuento,
                totalPedido: totalConDescuento + envioCosto,
                pagado: 0,
                pendiente: totalConDescuento + envioCosto,
                estado: 'pendiente',
                descuento: descuento
            };

            const detallesPedido = carrito.map(product => {
                const price = configDescuento?.tipoConfig === 'desable'
                    ? parseFloat(product.precioU.toString().replace('$', '').replace(',', ''))
                    : parseFloat(
                        descuento !== null
                            ? product.precioU.toString().replace('$', '').replace(',', '')
                            : product.precioM.toString().replace('$', '').replace(',', '')
                    );
                const subtotal = price * (product.quantity || 1);
                console.log("handleSendPedido -> Producto:", product.idProducto, "Precio usado:", price, "Subtotal:", subtotal);
                return {
                    idProductoTienda: product.idProducto,
                    idProducto: product.referencia,
                    cantidad: product.quantity || 1,
                    subtotal: subtotal,
                    totalPedido: subtotal,
                    idColor: product.selectedColor?.id,
                    idTalla: product.selectedSize?.id,
                    nomCategoria: product.idCategoria ?? product.categoria ?? null,
                };
            });

            console.log('Enviando datos al servidor:', { pedido, detallesPedido });

            const response = await axios.post(`${API}/api/pedidos/carrito`, {
                pedido,
                detallesPedido
            }, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            clearCarrito();

            const data = response.data;
            const numeroPedido = data.numeroPedido;

            let sucursalData;
            let numeroSucursal;
            try {
                const sucursalResponse = await axios.get(`${API}/api/pedidos/sucursal/${idSucursal}`);
                sucursalData = sucursalResponse.data;
                numeroSucursal = sucursalData.numSucursal;
            } catch (error) {
                // Si falla, intenta con idSucursal 1 por defecto
                try {
                    const sucursalResponseDefault = await axios.get(`${API}/api/pedidos/sucursal/1`);
                    sucursalData = sucursalResponseDefault.data;
                    numeroSucursal = sucursalData.numSucursal;
                } catch (error2) {
                    throw new Error('Número de sucursal no disponible');
                }
            }

            const formattedNumeroSucursal = formatPhoneNumber(numeroSucursal);

            let productList = 'Detalle de productos:\n\n';
            carrito.forEach((product) => {
                const price = configDescuento?.tipoConfig === 'desable'
                    ? parseFloat(product.precioU.toString().replace('$', '').replace(',', ''))
                    : parseFloat(
                        descuento !== null
                            ? product.precioU.toString().replace('$', '').replace(',', '')
                            : product.precioM.toString().replace('$', '').replace(',', '')
                    );

                const quantity = product.quantity || 1;
                const subtotal = price * quantity;
                productList += `${product.nomProducto} | ${quantity} | $${formatCurrency(price)} | $${formatCurrency(subtotal)}\n`;
            });
            productList += `\nTotal productos: ${totalProductosQuantity} unidades\n`;
            productList += `Costo del Pedido: $${formatCurrency(totalConDescuento)}\n`;
            productList += `Costo envío: $${formatCurrency(envioCosto)}\n`;
            productList += `Total a pagar: $${formatCurrency(totalConDescuento + envioCosto)}\n`;

            const mensajeWhatsApp =
                `Acabas de realizar un pedido con el número: *${numeroPedido}*.\n\n` +
                productList +
                `\nVer pedido: https://reymidascaps.com/viewOrder/${numeroPedido}\n\n` +
                `Para pago contra entrega solo debes pagar el envío por adelantado y en casa paga su pedido.`;

            const urlWhatsApp = `https://api.whatsapp.com/send?phone=${formattedNumeroSucursal}&text=${encodeURIComponent(mensajeWhatsApp)}`;

            window.location.href = urlWhatsApp;

        } catch (error) {
            console.error('Error al enviar el pedido:', error);
            alert(`Error al enviar el pedido: ${error.response?.data?.error || error.message}`);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <Modal size='xl' show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title className='text-dark fw-bold'>Esta es tu compra</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xs={12} md={8}>
                        <ListGroup variant="flush">
                            {carrito.map((product) => (
                                <ListGroup.Item key={product.idProducto}>
                                    <Row>
                                        <Col xs={3} md={4}>
                                            <Image src={product.image} width={100} rounded fluid />
                                        </Col>
                                        <Col xs={4} md={6}>
                                            <span className='fw-bold text-dark'>{product.nomProducto}</span>
                                            {product.categoria && (
                                                <div className="text-muted small">{product.categoria}</div>
                                            )}
                                            <div className="text-muted fw-bold">
                                                $ {formatCurrency(
                                                    configDescuento?.tipoConfig === 'desable'
                                                        ? parseFloat(product.precioU.toString().replace('$', '').replace(',', ''))
                                                        : parseFloat(
                                                            descuento !== null
                                                                ? product.precioU.toString().replace('$', '').replace(',', '')
                                                                : product.precioM.toString().replace('$', '').replace(',', '')
                                                        )
                                                )}
                                            </div>
                                        </Col>
                                        <Col xs={4} md={2} className="d-flex justify-content-end align-items-center">
                                            <Button
                                                variant='danger'
                                                className='d-flex justify-content-center align-items-center'
                                                onClick={() => handleRemoveProduct(product.idProducto, product.selectedColor, product.selectedSize)}
                                            >
                                                <Trash3Fill />
                                            </Button>
                                        </Col>
                                        <div className="d-flex justify-content-between align-items-center mt-2 w-100">
                                            <Button
                                                variant="danger"
                                                className="flex-grow-0"
                                                size="sm"
                                                style={{ width: '20%' }}
                                                onClick={() => handleDecreaseQuantity(product.idProducto, product.selectedColor, product.selectedSize)}
                                            >
                                                -
                                            </Button>
                                            <span
                                                className="mx-2 text-center border"
                                                style={{
                                                    flexGrow: 1,
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                {product.quantity || 1}
                                            </span>
                                            <Button
                                                variant="success"
                                                className="flex-grow-0"
                                                size="sm"
                                                style={{ width: '20%' }}
                                                onClick={() => handleIncreaseQuantity(product.idProducto, product.selectedColor, product.selectedSize)}
                                                disabled={product.quantity >= product.stock}
                                            >
                                                +
                                            </Button>
                                        </div>
                                    </Row>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Col>
                    <Col>
                        <div className="d-flex justify-content-between mt-3">
                            <strong className='fw-bold text-dark'>Subtotal:</strong>
                            <strong className='fw-bold text-muted'>${formatCurrency(totalPrecio)}</strong>
                        </div>

                        {porcentajeDescuento !== null && porcentajeDescuento > 0 ? (
                            <div className="d-flex justify-content-between mt-3">
                                <strong className='fw-bold text-dark'>Descuento aplicado:</strong>
                                <strong className='fw-bold text-danger'>-{porcentajeDescuento}%</strong>
                            </div>
                        ) : (
                            configDescuento?.tipoConfig !== 'desable' && porcentajeDescuento === null && (
                                <div className="d-flex justify-content-between mt-3">
                                    <strong className='fw-bold text-dark'>Precio aplicado:</strong>
                                    <strong className='fw-bold text-danger'>Mayorista</strong>
                                </div>
                            )

                        )}

                        {porcentajeDescuento !== null && porcentajeDescuento > 0 && (
                            <div className="d-flex justify-content-between mt-3">
                                <strong className='fw-bold text-dark'>Total con descuento:</strong>
                                <strong className='fw-bold text-muted'>${formatCurrency(totalConDescuento)}</strong>
                            </div>
                        )}

                        <div className="d-flex justify-content-between mt-3">
                            <strong className='fw-bold text-dark'>Envío:</strong>
                            <strong style={{ color: envioCosto > 0 ? 'inherit' : 'green' }}>
                                {isEnvioDisabled
                                    ? '+Costo de Envío'
                                    : (envioCosto > 0 ? `$ ${formatCurrency(envioCosto)}` : '¡GRATIS!')}
                            </strong>
                        </div>

                        <div className="d-flex justify-content-between mt-3">
                            <strong className='fw-bold text-dark'>Total a pagar:</strong>
                            <strong className='fw-bold text-dark'>${formatCurrency(totalConDescuento + envioCosto)}</strong>
                        </div>
                        {carrito.length === 0 ? (
                            <Button
                                variant='success'
                                className="mt-3 w-100 d-flex justify-content-center align-items-center"
                                disabled
                            >
                                No hay productos en el carrito
                            </Button>
                        ) : (
                            <Button
                                variant='success'
                                className="mt-3 w-100 d-flex justify-content-center align-items-center"
                                onClick={handleSendPedido}
                                disabled={isSending}
                            >
                                {isSending ? 'Enviando...' : <><Whatsapp className='me-2' size={18} /> Enviar pedido</>}
                            </Button>
                        )}

                        <Button
                            variant='danger'
                            className='mt-2 w-100 d-flex justify-content-center align-items-center'
                            onClick={handleClearCarrito}
                        >
                            <Trash3Fill /> Vaciar carrito
                        </Button>
                        <div className='mt-3'>
                            <p className='small text-muted text-center'>
                                Al enviar el pedido te redirigirá a WhatsApp con uno de nuestros asesores donde podrás terminar el proceso.
                            </p>
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}

export default CarUni;
